/**
 * Či používateľ v CookieYes povolil funkčné (preference) cookies.
 * Používa sa napr. pri ukladaní zvoleného jazyka.
 * Ak CookieYes ešte nie je načítaný alebo nie je dostupný (napr. localhost), vráti false.
 */
export function hasPreferencesConsent(): boolean {
	try {
		const consent = (globalThis as any).getCkyConsent?.()
		return !!consent?.categories?.functional
	} catch (e) {
		return false
	}
}
